import { usePageTrack } from '@v2/services/analytics.service';

import { css } from '@emotion/css'
import { mobileOnly } from '@styles/breakpoints';
import colors from '@styles/colors';
import { imgV2 as img } from '@styles/utils';

import Yoalty from '@v2/components/common/yotpo/widgets/yoalty';
import ReferralBanner from '@components/common/yotpo/presentational/referral-banner';

const styles = css({
    fontFamily: '"sofia-pro", sans-serif !important',
    margin: '0px !important',
    padding: '0px !important',

    '.yotpo-widget-hero-section': {
        '.yotpo-text-on-background': {
            backgroundSize: 'contain !important',
            backgroundColor: '#fcf4f2 !important',
        },
        '.yotpo-action-button-text': {
            fontFamily: '"sofia-pro", sans-serif !important',
            letterSpacing: '0.2em !important',
            fontSize: '13px !important',
            fontWeight: '700 !important',
        },
        '.yotpo-title': {
            fontFamily: '"sofia-pro", sans-serif !important',
            fontWeight: '700 !important',
            fontSize: '44px !important',
            marginBottom: 10,
        },
        '.yotpo-description': {
            fontFamily: '"sofia-pro", sans-serif !important',
            fontWeight: '700 !important',
            fontSize: '20px !important',
        },
    },

    '.yotpo-widget-my-rewards-widget': {
        '.yotpo-title': {
            fontFamily: '"sofia-pro", sans-serif !important',
            fontWeight: '700 !important',
            fontSize: '28px !important',
            marginBottom: 10,
        },
        '.yotpo-background': {
            background: '#FFECF0 !important',
        },
        '.yotpo-step-icon': {
            height: '100px !important',
        },
        '.yotpo-reward-steps-title': {
            marginBottom: '15px !important'
        },
        '.yopto-widget-button-text': {
            fontFamily: '"sofia-pro", sans-serif !important',
            letterSpacing: '0.2em !important',
            fontSize: '13px !important',
            fontWeight: '700 !important',
        }
    },
    '.yotpo-widget-campaign-widget': {
        background: '#EBF5F0 !important',

        '.yotpo-container-headline': {
            fontFamily: '"sofia-pro", sans-serif !important',
            fontWeight: '700 !important',
        },
        '.yotpo-completed-icon': {
            color: `${colors.WHITE} !important`
        },
        '.flexified-wrapper > div': {
            backgroundColor: '#00865A !important',
            borderRadius: '10px !important',

            '.yotpo-tile-wrapper > div': {
                backgroundColor: '#00865A !important',
                borderRadius: '10px !important',

                '.yotpo-title-text': {
                    color: 'white !important',
                    fontFamily: '"sofia-pro", sans-serif !important',
                    fontWeight: '700 !important',
                    marginBottom: 10,
                },
                '.yotpo-description-text': {
                    color: 'white !important',
                    fontFamily: '"sofia-pro", sans-serif !important',
                    fontWeight: '600 !important',
                }
            }
        },
        '.yotpo-overlay-tile': {
            backgroundColor: '#00865A !important',
            borderRadius: '10px !important',

            '.yotpo-action-button-text': {
                fontFamily: '"sofia-pro", sans-serif !important',
                letterSpacing: '0.2em !important',
                fontSize: '13px !important',
                fontWeight: '700 !important',
            },
        }
    },

    '.yotpo-coupons-redemption-widget': {
        fontFamily: '"sofia-pro", sans-serif !important',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: `url(${img('yotpo/bg-2.svg')})`,
        backgroundSize: 'cover',
        marginBottom: '-10px',

        '.yotpo-copy-code-button': {
            color: 'white !important',
            backgroundColor: 'rgb(0 134 90) !important',
            borderColor: 'rgb(0 134 90) !important',
            width: '220px !important',
            borderRadius: 10,
        },
        '.yotpo-points-balance-text-part': {
            color: 'rgb(0 134 90) !important',
        },
        '.yotpo-headline': {
            fontFamily: '"sofia-pro", sans-serif !important',
        },

        '.yotpo-coupons-redemption-widget-container': {
            paddingBottom: '0px !important',

            '.yotpo-heading': {
                fontFamily: '"sofia-pro", sans-serif !important',
                fontStyle: 'normal !important',
                fontWeight: '800 !important',
                fontSize: '28px !important',
                marginBottom: 20,
            },
            '.yotpo-description': {
                fontFamily: '"sofia-pro", sans-serif !important',
                fontWeight: '400 !important',
                fontSize: '16px !important',
            },
            '.yotpo-redemption-option-reward': {
                fontFamily: '"sofia-pro", sans-serif !important',
                fontWeight: '800 !important',
                fontSize: '64px !important',
            },
            '.yotpo-redemption-option-cost': {
                fontFamily: '"sofia-pro", sans-serif !important',
                fontWeight: '800 !important',
                fontSize: '17px !important',
                color: `${colors.NAVY} !important`
            },
            '.yotpo-rule': {
                fontFamily: '"sofia-pro", sans-serif !important',
            },
            '.yotpo-redemption-options-list': {
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                alignContent: 'center',
                alignItems: 'center',
            },
            '.yotpo-coupons-redemption-widget .three-in-row .yotpo-redemption-item': {
                width: 'auto !important',
            },
            '.yotpo-button-style': {
                borderRadius: 25,
                padding: '10px 20px',
                border: '2px solid',
                borderCollapse: 'collapse',
                textTransform: 'uppercase',
                textAlign: 'center',
                letterSpacing: '0.2em',
                cursor: 'pointer',
                WebkitTransition: '0.2s',
                transition: '0.2s',
                WebkitTextDecoration: 'none',
                textDecoration: 'none',
                backgroundColor: `${colors.NAVY} !important`,
                height: '100% !important',
                display: 'flex',
                marginLeft: 'auto',
                marginRight: 'auto',

                span: {
                    fontFamily: '"sofia-pro", sans-serif !important',
                    letterSpacing: '0.2em !important',
                    fontSize: '13px !important',
                    fontWeight: '700 !important',
                    width: '100% !important',
                },
            }
        }
    },

    '.yotpo-vip-tiers-widget': {
        backgroundColor: 'rgb(227, 235, 255) !important',

        '.yotpo-vip-tiers-headline': {
            fontFamily: '"sofia-pro", sans-serif !important',
            fontWeight: '800 !important',
            fontSize: '28px !important',
            marginBottom: '15px !important'
        },
        '.yotpo-vip-tier': {
            borderRadius: '10px !important',
            borderColor: 'white !important',
            backgroundColor: 'white !important',

            '.yotpo-vip-tier-name': {
                fontFamily: '"sofia-pro", sans-serif !important',
                fontWeight: '700 !important',
                fontSize: '25px !important',
                marginBottom: '8px !important'
            },
            '.yotpo-vip-tier-threshold': {
                fontFamily: '"sofia-pro", sans-serif !important',
            },
            '.yotpo-vip-tier-divider': {
                borderColor: 'rgb(227, 235, 255) !important'
            },
            '.yotpo-vip-tier-benefit-text': {
                fontFamily: '"sofia-pro", sans-serif !important',
                fontWeight: '500 !important',
                color: '#88a0db !important'
            },
            '.yotpo-vip-tier-icon-wrapper': {
                height: '200px !important'
            }
        }
    },
    '.yotpo-headline > .yotpo-inner-text': {
        fontStyle: 'normal !important',
        fontWeight: '700 !important',
        fontSize: '28px !important',
        color: colors.NAVY
    },

    '.referral': {
        background: '#EBF5F0',
        paddingTop: 100,
        paddingBottom: 100,

        '.referral-wrapper': {
            maxWidth: 1000,
            width: '100%',
            margin: 'auto',
        }
    },
    '.yotpo-title-text, .yotpo-description-text, .yotpo-header-text': {
        fontFamily: '"sofia-pro", sans-serif !important',
    },

    [mobileOnly]: {
        '.yotpo-widget-hero-section': {
            '.yotpo-title': {
                fontSize: '30px !important',
            },
            '.yotpo-description': {
                fontSize: '15px !important',
            },
        },
        '.referral': {
            paddingTop: 60,
            paddingBottom: 60,
        },
        '.yotpo-widget-referral-widget': {
            '.yotpo-background': {
                paddingTop: '60px !important',
            }
        },
        '.yotpo-text-and-buttons': {
            paddingBottom: '40px !important',
        }
    },

});

export default function LoyaltyProgramPage() {
    usePageTrack('Smart Rewards');

    return (
        <div className={`pageDashboard  ${styles}`}>
            <Yoalty widgetID={process.env.YOALTY_WIDGET_ID}/>
            <div className="referral">
                <ReferralBanner />
            </div>
        </div>
    );
}